import { CarouselBaseCard } from '@post-office/browser--growth-starburst/common/carouselBaseCard';

import {
	type CardImages,
	type CarouselCardProps,
} from '@post-office/browser--growth-starburst/common/carouselBaseCard/types';

import { commonTwcMessages } from '@post-office/browser--growth-starburst/common/constants';

import { defineMessages } from 'react-intl';

import { SearchCardIllustrationDark } from '../assets/SearchCardIllustrationDark';

import { SearchCardIllustrationLight } from '../assets/SearchCardIllustrationLight';

import { type JSX } from 'react/jsx-runtime';

export const SearchOnboardingCard = (props: CarouselCardProps): JSX.Element => {
	const images: CardImages = {
		component: <SearchCardIllustrationLight />,
		componentDark: <SearchCardIllustrationDark />,
	};
	return (
		<CarouselBaseCard
			messages={{ ...searchMessages, ...commonTwcMessages }}
			images={images}
			{...props}
		/>
	);
};

const searchMessages = defineMessages({
	heading: {
		defaultMessage: 'Find more with Search',
		description: 'Heading for the Search onboarding card',
		id: 'townsquare.twc-onboarding-widget.search-card.heading',
	},
	description: {
		defaultMessage: "Power up your searches with AI and find what you're looking for faster.",
		description: 'Description for the Search onboarding card',
		id: 'townsquare.twc-onboarding-widget.search-card.description',
	},
	cta: {
		defaultMessage: 'Try Search',
		description: 'Call to action text for the Search onboarding card',
		id: 'townsquare.twc-onboarding-widget.search-card.cta',
	},
});
